function format(str, values) {
  if (!str) {
    return str;
  }
  if (!Array.isArray(values)) {
    values = [values];
  }
  values.forEach((value, index) => {
    str = str.replace(new RegExp(`\\{${index}\\}`, 'g'), value);
  });
  return str;
}

export default format;
